<template>
    <div>
        <!-- ========== HEADER ========== -->
        <header id="header" class="u-header">

            <div class="u-header__section">
                <TopBar/>

                <div id="logoAndNav" class="container">
                    <!-- Nav -->
                    <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space">
                        <Logo/>

                        <!-- Responsive Toggle Button -->
                        <button type="button" class="navbar-toggler btn u-hamburger"
                                aria-label="Toggle navigation"
                                aria-expanded="false"
                                aria-controls="navBar"
                                data-toggle="collapse"
                                data-target="#navBar">
                            <span id="hamburgerTrigger" class="u-hamburger__box">
                              <span class="u-hamburger__inner"></span>
                            </span>
                        </button>
                        <!-- End Responsive Toggle Button -->
                    </nav>
                    <!-- End Nav -->
                </div>
            </div>
        </header>
        <!-- ========== END HEADER ========== -->

        <!-- ========== MAIN ========== -->
        <main id="content" role="main">
            <EditProfileBreadcumb/>
            <EditProfileContent/>
        </main>
        <!-- ========== END MAIN ========== -->

        <FooterA/>

        <GoToTop/>

        <script type="application/javascript" v-bind:src="tagsInputSrc"></script>
    </div>
</template>

<script>
    import TopBar from "../components/TopBar";
    import Logo from "../components/Logo";
    import GoToTop from "../components/GoToTop";
    import FooterA from "../components/FooterA";
    import EditProfileBreadcumb from "../components/EditProfileBreadcumb";
    import EditProfileContent from "../components/EditProfileContent";
    import {JS_FILES} from "../settings/scripts";

    export default {
        name: "EditProfile",
        components: {EditProfileContent, EditProfileBreadcumb, FooterA, GoToTop, Logo, TopBar},
        data() {
            return {
                tagsInputSrc: JS_FILES.tagsInput
            }
        }
    }
</script>

<style scoped>

</style>